import React, { useMemo } from 'react';

const CONFETTI_COLORS = ['#FAC775', '#F5C4B3', '#1D9E75', '#FAECE7', '#FFFFFF'];

const WelcomeStep = ({ fullName, onExplore }) => {
  const confetti = useMemo(
    () =>
      Array.from({ length: 28 }, (_, i) => {
        const size = 6 + Math.round(Math.random() * 6);
        return {
          id: i,
          left: `${Math.random() * 100}%`,
          color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
          width: size,
          height: Math.round(size * 1.6),
          duration: `${(4 + Math.random() * 3).toFixed(2)}s`,
          delay: `${(Math.random() * -6).toFixed(2)}s`,
          drift: `${Math.round((Math.random() - 0.5) * 70)}px`,
        };
      }),
    []
  );

  const firstName = (fullName || '').trim().split(' ')[0] || 'friend';

  return (
    <div className="ob-welcome-page">
      {confetti.map((c) => (
        <span
          key={c.id}
          className="ob-confetti"
          style={{
            left: c.left,
            background: c.color,
            width: c.width,
            height: c.height,
            animationDuration: c.duration,
            animationDelay: c.delay,
            '--drift': c.drift,
          }}
        />
      ))}

      <div className="ob-welcome-card">
        <div className="ob-welcome-bowl">🍲</div>
        <h1 className="ob-welcome-title">Welcome to the table,<br /><em>{firstName}.</em></h1>
        <p className="ob-welcome-sub">Your dinner invitation has been accepted.</p>
        <div className="ob-welcome-pill">
          <span>🍳 Cook</span>
          <span>📮 Share</span>
          <span>🏆 Win</span>
        </div>
      </div>

      <div className="ob-welcome-footer">
        <p>Your feed is ready</p>
        <button type="button" className="ob-btn-primary" onClick={onExplore}>Explore Nemonto</button>
      </div>
    </div>
  );
};

export default WelcomeStep;
